
import { Component, Vue, Prop } from 'vue-property-decorator';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import BenzAMRRecorder from 'benz-amr-recorder';
import bbsDialog from '@/components/BbsDialog/index.vue';
import { complain } from '../../api/orderComplaint';
import { addCustomer } from '@/api/customer';

import { ComplaintModule } from '@/store/modules/complaint';
import { UserModule } from '@/store/modules/user';
import { checkPermissionCompanyFromOrderType, checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { closeOrder } from '@/api/orderTask';

@Component({
  name: 'OrderDetail',
  components: {
    dialogImgLarge,
    bbsDialog,
  },
  filters: {
    getOrderServiceDealType(value: any) {
      switch (parseInt(value)) {
        case 1:
          value = '派给自己';
          break;
        case 2:
          value = '指派';
          break;
        case 3:
          value = '转单';
          break;
        default:
          value = '未处理';
          break;
      }
      return value;
    },
    getAppointmentime(val: any) {
      if (val && val.length > 0) {
        if ('appointment_time' in val[0]) {
          return val[0].appointment_time;
        } else {
          return '暂无';
        }
      } else {
        return '暂无';
      }
    },
    getTaskDealType(value: any) {
      switch (parseInt(value)) {
        case 0:
          value = '未处理';
          break;
        case 1:
          value = '远程';
          break;
        case 2:
          value = '上门';
          break;
        case 3:
          value = '寄修';
          break;
        case 4:
          value = '转单';
          break;
        default:
          value = '未处理';
          break;
      }
      return value;
    },
    getArraignmentState(value: any) {
      switch (parseInt(value)) {
        case 0:
          value = '未处理';
          break;
        case 1:
          value = '审批通过';
          break;
        case 3:
          value = '审批不通过';
          break;
        case 5:
          value = '审批关闭';
          break;
      }
      return value;
    }
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogOrderDetailVisible!:Boolean;

  @Prop({
    type: Object,
    default: () => ({
      order: {},
      order_service: {}
    })
  })detail!:any;

  @Prop({
    type: Object,
    default: () => ({})
  })task!:any;

  @Prop({
    type: Boolean,
    default: false
  })isOrderTask!: Boolean;
  @Prop({
    type: Boolean,
    default: false
  })isOrderEnterTask!: Boolean;
  @Prop({
    type: Boolean,
    default: false
  })isOrderProgress?: Boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })orderProgressData?: {};

  @Prop({
    type: Boolean,
    default: false
  })showComplaintBtn!: Boolean;
  @Prop({
    type: Boolean,
    default: false
  })showBJD!: Boolean;

  private orderDetailActiveName = 'first'
  private complainDialogVisible = false;
  private isCustomerModule=false;

  private isTaskClose=false;

  created() {
    // 李闯说角色的
    this.isCustomerModule = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
    // 关闭任务
    if (this.isOrderEnterTask) {
      this.isTaskClose = checkPermissionCompanyFromOrderType(UserModule.getCompanyId, Type.TASK_CLOSE, this.detail.order.order_type);
    }
    if (this.isOrderProgress) {
      this.orderDetailActiveName = 'progress';
    } else {
      this.orderDetailActiveName = 'first';
    }
  }

  close() {
    this.$emit('close', false);
    this.orderDetailActiveName = 'first';
  }

  imgLargeHandle(val: [], index: number, type:number) {
    if (type === 10) {
      val.forEach((element:any) => {
        element.img_url = element.full_path;
      });
    }
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private getOrderType(orderType:any) {
    let kind = "";
    if (parseInt(orderType) === 1) {
      kind = "其他";
    } else if (parseInt(orderType) === 2) {
      kind = "维保";
    } else if (parseInt(orderType) === 3) {
      kind = "安装";
    } else if (parseInt(orderType) === 4) {
      kind = "巡检";
      if (parseInt(this.detail.order_service.polling_check_abnormal_count) > 0) {
        kind = "巡检" + ' 巡异';
      }
    } else {
      kind = "维保";
    }
    return kind
  }
  private getAnwer(answer:any) {
    let str = '';
    if (parseInt(answer.question_type) !== 3) {
      let a = JSON.parse(answer.question_answer);
      for (let index = 0; index < a.length; index++) {
        const element = a[index];
        if (parseInt(element.select) === 1) {
          str = str + element.title + '、';
        }
      }
      str = str.substring(0, str.length - 1);
    } else {
      str = answer.question_answer;
    }

    return str;
  }
  voiceHandle(val: any, index: number) {
    let _this = this;
    let amr = new BenzAMRRecorder();

    for (let i = 0; i < val.length; i++) {
      if (i === index) {
        val[i].isPlaying = true;
      }
      val[i].isPlaying = false;
    }

    amr.initWithUrl(val[index].full_path).then(function() {
      val[index].isPlaying = true;
      amr.play();
      _this.$set(val, index, val[index]);
    });

    amr.onEnded(function() {
      amr.stop();
      val[index].isPlaying = false;
      _this.$set(val, index, val[index]);
    });
  }

  tabBeforeHandle(activeName: string, oldActiveName: string) {
    if (activeName === 'last') {
      let routeData = this.$router.resolve({
        path: '/OrderTrack',
        query: {
          order_id: this.detail.order.id,
          servicer_company_id: this.detail.order_service.servicer_company_id
        }
      });
      window.open(routeData.href);
      return false;
    }
  }
  // 生成报价单
  private handleBJD() {
    this.$router.push({
      path: '/OrderServicer/toquote',
      query: {
        detail: JSON.stringify(this.detail)
      }
    });
  }
  // 关闭任务
  private handlCloseTask() {
    let that = this;
    this.$prompt('确认关闭任务?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /^\S.{0,}$/,
      inputPlaceholder: '请输入关闭任务备注',
      inputErrorMessage: '请输入关闭任务备注',
      type: 'warning'
    }).then((value:any) => {
      let pamars:any = {
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        user_id: UserModule.getUserId,
        user_name: UserModule.getUserName,
        order_task_id: that.task.id,
        servicer_close: 1,
        remark: value.value
      };
      closeOrder(pamars).then((res:any) => {
        that.showSecussMsg(res.msg);
        that.$emit('close', false);
        that.$emit('refreshList', true);
      }).catch(err => {
        that.showErrorMsg(err.msg);
      });
    }).catch(() => {

    });
  }
  handleShowComplain() {
    const detail = this.detail as any;
    const state = parseInt(detail.order_service.complaint_state);
    let item = ComplaintModule.list.find(item => item.id === parseInt(detail.order.id));
    if (item === undefined) {
      item = {
        id: parseInt(detail.order.id),
        stage: state
      };
      ComplaintModule.addItem(item);
    }
    if ([0, 8].includes(item.stage)) {
      this.complainDialogVisible = true;
    } else {
      this.bbsHandle(this.detail);
    }
  }

  handleComplain() {
    const detail = this.detail as any;
    const params = {
      order_id: detail.order.id,
      order_service_id: detail.order_service.id,
      // 第一次投诉，状态设置为2
      complaint_state: 2,
      company_name: detail.order_service.servicer_company_name,
      order_num: detail.order.order_num
    };
    complain(params).then(res => {
      const item = {
        id: parseInt(detail.order.id),
        stage: 2
      };
      ComplaintModule.switchStage(item);
      this.bbsHandle(this.detail);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  clickDocument(val: any) {
    const url = val.full_path;
    const filename = val.original_name;
    let arr = ['pdf', 'html'];
    let nameArr = filename.split('.');
    if (arr.includes(nameArr[1])) {
      window.open(url);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  }

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;
  private complaintState:number = 1;
  bbsHandle(r: any) {
    this.complainDialogVisible = false;
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
    this.complaintState = parseInt(r.order_service.complaint_state);
  }
  closeBbs(value: boolean) {
    this.bbsDialogVisible = value;
  }
  private addUserToCustomer(val:any) {
    if (parseInt(val.order.customer_type) === 1) {
      let pamars:any = {
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        user_id: UserModule.getUserId };
      pamars.add_type = 2;
      pamars.type = 1;
      pamars.is_order = 1;
      pamars.customer_company_id = val.order.customer_company_id;
      addCustomer(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
      return;
    }
    this.$router.push({
      path: '/Customer/toCustomer',
      query: { 'orderDetail': JSON.stringify(val) }
    });
  }
  private relationDetailHandle(val:any) {
    this.$emit('relationDetailHandle', val);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
